import { TextField } from "@mui/material";
import { MobileDatePicker } from '@mui/x-date-pickers';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LeftIcon from 'mdi-react/ChevronLeftIcon';
import RightIcon from 'mdi-react/ChevronRightIcon';
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import FieldErrorTooltip from '../FieldErrorTooltip';
import { getCurrentLanguage } from '../../../translations/i18n';
import { formatMoment } from '../../../utils/dates';
// import { formatDateToUtc } from '../../../utils/dates'
interface ReduxDatePickerProps {
    input: {
        value: string | Date | undefined;
        onChange: any;
        onBlur: any;
    };
    label: string;
    invalidLabel: string;
    meta: any;
    [key: string]: any;
}
/** Used to connect redux forms with mui/pickers date picker */
const ReduxDatePicker = ({ input: { onChange, value, onBlur }, label, invalidLabel, clearable, meta: { invalid, error, submitFailed }, disablePast, disableFuture, minDate, maxDate, error: externalError, fieldVariant, ...custom }: ReduxDatePickerProps) => {
    const [locale, setLocale] = useState<string>(getCurrentLanguage());
    useEffect(() => {
        const currentLocale = getCurrentLanguage();
        setLocale(currentLocale);
    }, [locale, setLocale]);
    // Clear must send null, not undefined: redux-form ignores change(field, undefined) for a field that has an initial value
    const toolbarTitle = value ? dayjs(value).format('YYYY') : dayjs().format('YYYY');
    return (<MobileDatePicker inputFormat='DD.MM.YYYY' toolbarFormat='ddd, MMM D' toolbarTitle={toolbarTitle} value={value || null} onClose={() => onBlur()} onChange={(momentValue) => onChange(momentValue ? formatMoment(momentValue, 'YYYY-MM-DD') : null)} components={{
            LeftArrowIcon: LeftIcon,
            RightArrowIcon: RightIcon
        }} componentsProps={{
            day: {
                disableRipple: true,
                sx: {
                    '&.MuiPickersDay-today:not(.Mui-selected)': {
                        backgroundColor: 'transparent !important',
                        border: 'none !important',
                    }
                }
            },
        actionBar: {
            actions: ['clear', 'accept'] as any, // Clear replaces Cancel (Esc / backdrop still dismiss)
            sx: {
                justifyContent: 'space-between',
                padding: '8px 16px',
                '& .MuiButton-root': {
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' }
                }
            }
        }
        } as any} renderInput={(params) => {
            const { InputProps, ...rest } = params;
            const showError = externalError || (invalid && submitFailed);
            const isUnderline = fieldVariant === 'underline';
            return (<div style={{ ...(isUnderline ? {} : { marginBottom: '0.5rem' }) }}>
                {label && !isUnderline && (<div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingBottom: '0.4rem' }}>
                    <label style={{ fontFamily: 'CircularRegular', display: 'inline-block' }}>{label}</label>
                </div>)}
                <TextField {...rest} {...custom} variant="standard"
                    {...(isUnderline && label ? { label, InputLabelProps: { shrink: true } } : {})}
                    InputProps={{
                        ...InputProps,
                        endAdornment: null,
                        startAdornment: <DateRangeIcon style={{ color: 'gray', width: fieldVariant === 'underline' ? 18 : 22, height: fieldVariant === 'underline' ? 18 : 22, marginRight: 8 }}/>,
                        sx: fieldVariant === 'underline' ? {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px 0 5px 0',
                            '& input': { padding: '0', cursor: 'pointer' },
                        } : {
                            background: '#E7ECEF',
                            borderRadius: '6px',
                            minHeight: '55px',
                            padding: '0 14px',
                            display: 'flex',
                            alignItems: 'center',
                            '&::before, &::after': { content: 'none' },
                            '& input': { padding: '0', cursor: 'pointer' },
                        }
                    }} error={showError}/>
                <FieldErrorTooltip error={error} visible={showError} />
            </div>);
        }} disablePast={disablePast} disableFuture={disableFuture} minDate={minDate} maxDate={maxDate} {...custom}/>);
};
export default ReduxDatePicker;
